import { FullPageSpinner } from "@resamare/ui";

import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Navigation from "@/components/Navigation/Navigation";

function DefaultLayout() {
    return (
        <Suspense fallback={<FullPageSpinner />}>
            <Outlet />
            <Navigation />
        </Suspense>
    );
}

export default DefaultLayout;
